// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2267d471","573":"b07a9044","703":"b62ffdc7","787":"f41af1bb"}[chunkId] + ".chunk.js";
};